import { Stack } from 'expo-router';
import React from 'react';

function DirectDepositBenefitsLayout() {
  return <Stack />;
}

export default DirectDepositBenefitsLayout;
